<template>
    <!-- 商圈資訊頁外層 -->
    <div class="marketplace" ref="BigMain" @scroll="scrollEvent">

        <navigation-bar v-if="$public.isCordova()" Back Bell :name="pageData.showName" :location="pageData.showCity" :areaType="pageData.shoppingAreaInfo.shoppingType"/>
        <navigation-bar v-else :name="pageData.showName" :location="pageData.showCity" :areaType="pageData.shoppingAreaInfo.shoppingType"/>

        <div class="tabs" v-if="$public.isCordova()">
            <div @click="toSlide(tab[0])" :class="{active : tabNum===tab[0]}" class="tab1">
                資訊
            </div>
            <div @click="toSlide(tab[1])" :class="{active : tabNum===tab[1]}" class="tab2" v-show="pageData.shoppingAreaInfo.nowActivityId > 0">
                活動
            </div>
            <div @click="toSlide(tab[2])" :class="{active : tabNum===tab[2]}" class="tab3" v-if="isArticleTitle">
                貼文
            </div>
        </div>
        <div class="main">
            <!--APP用-->
            <swiper ref="mySwiper" :options="swiperOptions" v-if="$public.isCordova()">
                <swiper-slide v-if="isFormDataReload">
                    <div class="swipe-content" ref="info" @scroll="handleScroll">
                        <router-view class="swipe-con" :outerAreaInfo="pageData.shoppingAreaInfo" @activeTab="tabs"/>
                    </div>
                </swiper-slide>

                <swiper-slide v-if="pageData.shoppingAreaInfo.nowActivityId > 0 && isFormDataReload">
                    <div class="swipe-content" ref="activity" @scroll="handleScroll">
                        <router-view class="swipe-con" name="activity" :shopAreaId="pageData.shopAreaId"/>
                    </div>
                </swiper-slide>

                <swiper-slide v-if="isArticle && isFormDataReload">
                    <div class="swipe-content" ref="article" @scroll="handleScroll">
                        <router-view class="swipe-con" name="article" @isArticle="ArticleF"/>
                    </div>
                </swiper-slide>
            </swiper>
            <!--網頁用-->
            <template v-else>
                <router-view :outerAreaInfo="pageData.shoppingAreaInfo" v-if="this.$route.name==='MarketplaceInfo' && isFormDataReload"/>

                <router-view v-if="this.$route.name==='MarketplaceActivity' && isFormDataReload" :shopAreaId="pageData.shopAreaId"/>

                <router-view v-if="this.$route.name==='MarketplaceArticle' && isFormDataReload"/>

                <router-view v-if="this.$route.name!=='MarketplaceInfo' && this.$route.name!=='MarketplaceActivity' && this.$route.name!=='MarketplaceArticle'"/>
            </template>
        </div>
        <loading
                :active.sync= pageData.isLoading
                :can-cancel="false"
                :is-full-page="true">
        </loading>
        <toast/>
    </div>
</template>

<script>
    import * as mutationTypes from '@/store/mutationTypes'
    import Toast from "@/components/Toast"
    import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
    import 'swiper/css/swiper.css'
    import * as constDefine from '@/store/constDefine'
    import {SpinnerWheelType} from "@/store/constDefine";
    let vm = null;

    export default {
        name: 'MarketplaceIndex',
        components: {
            Swiper,
            SwiperSlide,
            Toast,
        },
        data() {
            return {
                isFormDataReload: false, //用來當this.$store.state.shopAreaInfo有資料刷新時，才載入router view
                pageData: {
                    isLoading: false,
                    shopAreaId: Number(this.$store.state.shopAreaInfo.id),
                    shoppingAreaInfo: {},       //商圈資料
                    // shoppingActInfo: {},        //商圈活動資料
                    showName: '',           //顯示用商圈名稱
                    showCity: '',           //顯示用城市名稱
                    lng: 0,
                    lat: 0,
                },
                //目前索引值
                tabNum: 0,
                //頁籤索引值 [資訊,活動,貼文]
                tab:[0,1,2],
                //捲動紀錄定位
                scrollIntro: [0,0,0],
                scrollActivity: [0,0,0],
                //是否正在按介紹、店家、地圖
                hasTab:[false,false,false],
                //判斷往上或往下滾動
                x: 0,
                //swiper套件設定
                swiperOptions: {
                    on: {
                        slideChange(){
                            // 这里有坑，需要注意的是：this 指向的是 swpier 实例，而不是当前的 vue， 因此借助 vm，来调用 methods 里的方法
                            const index = this.activeIndex
                            vm.tabNumber(index);
                        },
                    },
                    breakpoints: {
                        //電腦版不給左右滑動
                        1024: {
                            noSwipingSelector: '.swiper-slide',
                            //autoHeight: true,
                            slideSpeed: 0,
                            speed: 0,
                        }
                    },
                    /*hashNavigation: {
                        replaceState: true,
                        watchState: true,
                    },*/
                },
                activeTab:'',
                isArticle: true,
                isArticleTitle: false,
            }
        },
        created() {
            vm = this;
        },
        mounted () {
            if(this.$auth.isAdminLogin() && !this.$public.isCordova()) {
                if(Number(this.$crypto.decryptText(this.$auth.getAdminToken()).split(";")[0]) < 0) {
                    this.$auth.setAdminToken('');
                }
            }

            //載入初始資料
            let self = this;
            self.isFormDataReload = false;
            if (self.$store.state.shopAreaInfo.officialName !== self.$route.params.officialName) {
                self.$http.fetch`GetOfficialNameToShoppingAreaId${{
                    officialName: self.$route.params.officialName,
                }} ${json => {
                    self.$store.commit("updateShopAreaInfo", json.data);
                    self.pageData.shopAreaId = self.$store.state.shopAreaInfo.id;
                    self.isFormDataReload = true;
                    self.setupData();

                    if(!self.$public.isCordova()) {
                        sessionStorage.setItem('openShoppingAreaOfficialName', self.$route.params.officialName);
                    }
                }}`;
            } else {
                self.pageData.shopAreaId = self.$store.state.shopAreaInfo.id;
                self.isFormDataReload = true;
                self.setupData();
            }
        },
        activated(){
            const fullWidth = window.innerWidth;
            if(fullWidth>=1024){
                //網頁版紀錄捲動位置
                this.$refs.BigMain.scrollTop = this.scrollIntro[0];
            }else{
                if (this.$public.notNull(this.$refs.info?.scrollTop) &&
                    this.$public.notNull(this.$refs.activity?.scrollTop)) {

                    //手機版紀錄捲動位置
                    if (this.activeTab === 'map') {
                        this.$refs.info.scrollTop = this.scrollIntro[2];
                        this.$refs.activity.scrollTop = this.scrollActivity[2];
                    } else if (this.activeTab === 'brand') {
                        this.$refs.info.scrollTop = this.scrollIntro[1];
                        this.$refs.activity.scrollTop = this.scrollActivity[1];
                    } else {
                        this.$refs.info.scrollTop = this.scrollIntro[0];
                        this.$refs.activity.scrollTop = this.scrollActivity[0];
                    }
                }
            }
        },
        methods: {

            /** 載入資料 */
            setupData: function () {

                let pData = this.pageData;
                let self = this;
                pData.isLoading = true;

                //取得 GPS
                self.getGpsLocation()
                    .then(
                        self.getShoppingAreaInfo
                    )
                    // .then(
                    //     self.getShoppingActInfo
                    // )
                    .then( () => {
                            self.processScreenData();
                            pData.isLoading = false;
                        }
                    )
                    .catch((error) => {
                        pData.isLoading = false;
                        self.$store.commit(mutationTypes.SHOW_TOAST, error);
                    });

                self.getWheelGame().then(gameSetting => {
                    if (JSON.stringify(gameSetting) !== JSON.stringify({})) {
                        this.$router.replace({name: 'Turntable', params: {settingData: JSON.stringify(gameSetting),
                                type: SpinnerWheelType.SHOPPING_AREA.VALUE.toString()}});
                    }
                });
            },

            /** 取得GPS位置 */
            getGpsLocation: function () {
                let self = this;
                return new Promise(function(resolve, reject) {
                    let onSuccess = function (position) {
                        self.lng = position.coords.longitude;
                        self.lat = position.coords.latitude;
                        //完畢
                        resolve();
                    };

                    let onError = function (error) {
                        // reject("無法定位GPS");
                        //完畢
                        resolve();
                    };

                    self.$public.getGpsLocation(onSuccess, onError);
                });
            },

            /** 取得商圈資訊 */
            getShoppingAreaInfo: function () {
                let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈列表
                    self.$http.fetch`GetShoppingAreaInfo${{
                        shopAreaId: pData.shopAreaId,
                        isOffersList: true,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            pData.shoppingAreaInfo = json.data;
                            //完畢
                            resolve();

                        } else {
                            reject("無法讀取商圈資訊");
                        }
                    }}`;
                });
            },

            /** 取得商圈活動資訊 */
            getShoppingActInfo: function () {
                let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈目前活動資訊
                    self.$http.fetch`GetShoppingNowActInfo${{
                        shopAreaId: pData.shopAreaId,
                    }} ${json => {
                        if (self.$public.notNull(json.data)) {
                            pData.shoppingActInfo = json.data;
                            //完畢
                            resolve();

                        } else {
                            //完畢
                            resolve();
                        }
                    }}`;
                });
            },

            /** 處理一些顯示用的資料 */
            processScreenData: function () {
                let pData = this.pageData;
                let self = this;
                return new Promise(function(resolve, reject) {
                    //夜市商圈列表
                    if (self.$public.notNull(pData.shoppingAreaInfo)){
                        pData.showName = pData.shoppingAreaInfo.showName;
                        let typeName = '';

                        //商圈用，主辦方類型 0:其他 1:串門子 2:商圈 3:夜市 4:市集 5:店家
                        if (self.$public.notNull(pData.shoppingAreaInfo?.shoppingType)) {
                            switch (Number(pData.shoppingAreaInfo.shoppingType)) {
                                case constDefine.ShopAreaType.Other:
                                    typeName = '其他';
                                    break;
                                case constDefine.ShopAreaType.Oin:
                                    typeName = '串門子';
                                    break;
                                case constDefine.ShopAreaType.ShoppingArea:
                                    typeName = '商圈';
                                    break;
                                case constDefine.ShopAreaType.NightMarket:
                                    typeName = '夜市';
                                    break;
                                case constDefine.ShopAreaType.Market:
                                    typeName = '市集';
                                    break;
                                case constDefine.ShopAreaType.Store:
                                    typeName = '店家';
                                    break;
                            }
                        }

                        pData.showCity = `${pData.shoppingAreaInfo.showCity} | ${typeName}`;
                    }
                    //完畢
                    resolve();
                });
            },

            toSlide(index) {
                this.$refs.mySwiper.$swiper.slideTo(index)
            },
            tabNumber(index) {
                this.tabNum = index;
            },
            //切換分頁捲動滾動到記錄位置
            tabs(tab){
                this.activeTab=tab
                this.hasTab[this.tabNum] = true

                if (this.$public.notNull(this.$refs.info?.scrollTop) &&
                    this.$public.notNull(this.$refs.activity?.scrollTop)) {
                    if (this.activeTab === 'map') {
                        this.$refs.info.scrollTop = this.scrollIntro[2];
                        this.$refs.activity.scrollTop = this.scrollActivity[2];
                    } else if (this.activeTab === 'brand') {
                        this.$refs.info.scrollTop = this.scrollIntro[1];
                        this.$refs.activity.scrollTop = this.scrollActivity[1];
                    } else {
                        this.$refs.info.scrollTop = this.scrollIntro[0];
                        this.$refs.activity.scrollTop = this.scrollActivity[0];
                    }
                }
            },
            //頁面滾動時 介紹、店家、地圖按鈕往上滑被收起，往下滑被展開
            handleScroll(){
                let h;
                if(this.tabNum===0){
                    h = this.$refs.info.scrollTop;
                    if(this.activeTab==='map'){
                        this.scrollIntro[2] = h;
                    }else if(this.activeTab==='brand'){
                        this.scrollIntro[1] = h;
                    }else{
                        this.scrollIntro[0] = h;
                    }

                }else if(this.tabNum===1){
                    h = this.$refs.activity.scrollTop;
                    if(this.activeTab==='map'){
                        this.scrollActivity[2] = h;
                    }else if(this.activeTab==='brand'){
                        this.scrollActivity[1] = h;
                    }else{
                        this.scrollActivity[0] = h;
                    }
                }

                let scroll = h - this.x
                this.x = h

                if (this.$public.notNull(document.getElementsByClassName('sub-tab')[this.tabNum]?.classList)) {
                    if (scroll <= 0 || h < 80 || this.hasTab[this.tabNum]) {
                        //滾動往下或正在按分頁按鈕時
                        document.getElementsByClassName('sub-tab')[this.tabNum].classList.add("top-button-show")
                    } else {
                        //滾動往上
                        document.getElementsByClassName('sub-tab')[this.tabNum].classList.remove("top-button-show")
                    }
                }
                this.hasTab[this.tabNum] = false;
            },
            //捲動紀錄位置
            scrollEvent() {
                const fullWidth = window.innerWidth;
                if(fullWidth>=1024){
                    //網頁版紀錄捲動位置
                    this.scrollIntro[0] = this.$refs.BigMain.scrollTop;
                }
            },
            //APP版監聽是否有文章，無文章就隱藏區塊和按鈕
            ArticleF(val){
                this.isArticle= val
                this.isArticleTitle = val
            },

            getWheelGame: function () {
                const isToday = (date) => {
                    if (date === undefined || date === null || date === '')
                        return false

                    const today = new Date()
                    return date.getDate() === today.getDate() &&
                        date.getMonth() === today.getMonth() &&
                        date.getFullYear() === today.getFullYear()
                }

                return new Promise((resolve, reject) => {
                    let wheelGameLoadedAt = window.sessionStorage.getItem('shoppingWheelGameLoadedAt');
                    let wheelGame = null;
                    let date = null;
                    let id = 0;

                    if (wheelGameLoadedAt) {
                        wheelGame = this.$crypto.uriComponentToObject(wheelGameLoadedAt);
                        for (const w of wheelGame) {
                            if (w.id === this.pageData.shopAreaId) {
                                id = w.id;
                                date = new Date(w.date)
                            }
                        }
                    }

                    if (!this.$auth.isAdminLogin()) {
                        resolve({});
                        return;
                    }

                    if (isToday(date)){
                        resolve({});
                        return;
                    }

                    let data = [];
                    if (id !== 0) {
                        for (let wg of wheelGame) {
                            if (wg.id === this.pageData.shopAreaId) {
                                wg.date = new Date().toLocaleString(undefined,{ hour12: false });
                                break;
                            }
                        }
                        data = wheelGame;
                    } else {
                        if (wheelGame !== null) {
                            data = [...wheelGame];
                        }
                        data.push({
                            id: this.pageData.shopAreaId,
                            date: new Date().toLocaleString(undefined,{ hour12: false }),
                        });
                    }
                    window.sessionStorage.setItem('shoppingWheelGameLoadedAt', this.$crypto.objectToURIComponent(data));

                    this.$http.fetchWithAuth`GetWheelGame${{
                        "type": SpinnerWheelType.SHOPPING_AREA.VALUE,
                        "shoppingAreaId": this.pageData.shopAreaId,
                    }}
                    ${json => {
                        if (json.status){
                            resolve(json.data);
                        } else {
                            reject('轉盤遊戲設定撈取錯誤');
                        }
                    }}`;
                })
            },
        },
        watch: {
            "$route.name"(newName, oldName) {
                if (newName === "MarketplaceInfo" && this.isFormDataReload) {
                    this.setupData()
                }
            }
        },
    }
</script>

<style lang="less" scoped src="../../less/complex.less"/>